import { accountantIbkApi, clientIbkApi } from '@ibk/shared-config';
const SEARCH_CONTRACTS_URL = '/v1/benefits/contracts/search';
const buildSearchContractsBody = ({ document, status, limit, offset, sort }) => ({
    ...(document ? { document: document.replace(/[^A-Za-z0-9]/g, '').toUpperCase() } : {}),
    ...(status ? { status } : {}),
    ...(limit !== undefined ? { limit } : {}),
    ...(offset !== undefined ? { offset } : {}),
    ...(sort ? { sort } : {}),
});
export { buildSearchContractsBody };
const transformSearchContractsResponse = (response) => response.result;
export const accountantContractStatusApi = accountantIbkApi.injectEndpoints({
    endpoints: build => ({
        searchAccountantEmissorContracts: build.query({
            query: params => ({
                url: SEARCH_CONTRACTS_URL,
                method: 'POST',
                body: buildSearchContractsBody(params),
            }),
            transformResponse: transformSearchContractsResponse,
            providesTags: ['EmissorContract'],
        }),
    }),
});
export const clientContractStatusApi = clientIbkApi.injectEndpoints({
    endpoints: build => ({
        searchClientEmissorContracts: build.query({
            query: params => ({
                url: SEARCH_CONTRACTS_URL,
                method: 'POST',
                body: buildSearchContractsBody(params),
            }),
            transformResponse: transformSearchContractsResponse,
            providesTags: ['EmissorContract'],
        }),
    }),
});
export const { useSearchAccountantEmissorContractsQuery } = accountantContractStatusApi;
export const { useSearchClientEmissorContractsQuery } = clientContractStatusApi;
